import styled from 'styled-components'

export const HardwareImage = styled.img`
height: 105px;
`
